const WORDMARK_CREAM = '/assets/logos/wordmark-cream.png';

// linkPrefix: "#" on the landing page, "/#" on external pages so section links route home.
export const MarketingFooter = ({ linkPrefix = '#' }) => (
  <footer className="footer" data-testid="marketing-footer">
    <div className="container">
      <div className="foot-top">
        <div className="foot-brand">
          <img src={WORDMARK_CREAM} alt="Milk" />
          <p>The execution layer for conversation. You talk; Milk keeps the work moving.</p>
          <div className="foot-social">
            <a href="#" aria-label="X"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.9 2H22l-7 8 8.2 12h-6.4l-5-7.3L6 22H2.9l7.5-8.6L2 2h6.6l4.5 6.6L18.9 2zm-2.2 18h1.7L7.4 4H5.6l11.1 16z" /></svg></a>
            <a href="#" aria-label="LinkedIn"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M4.98 3.5A2.5 2.5 0 1 1 0 3.5a2.5 2.5 0 0 1 4.98 0zM0 8h5v16H0V8zm7.5 0H12v2.2h.1c.6-1.1 2.1-2.3 4.4-2.3 4.7 0 5.5 3 5.5 7V24h-5v-6.5c0-1.6 0-3.6-2.2-3.6s-2.5 1.7-2.5 3.5V24H7.5V8z" /></svg></a>
            <a href="#" aria-label="YouTube"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M23 7.5a3 3 0 0 0-2.1-2.1C19 5 12 5 12 5s-7 0-8.9.4A3 3 0 0 0 1 7.5 31 31 0 0 0 .6 12 31 31 0 0 0 1 16.5a3 3 0 0 0 2.1 2.1C5 19 12 19 12 19s7 0 8.9-.4a3 3 0 0 0 2.1-2.1A31 31 0 0 0 23.4 12 31 31 0 0 0 23 7.5zM9.6 15.4V8.6l6 3.4-6 3.4z" /></svg></a>
          </div>
        </div>
        <div className="foot-cols">
          <div className="foot-col"><h4>Product</h4><a href={`${linkPrefix}how`}>How it works</a><a href="/pricing" data-testid="footer-pricing-link">Pricing</a><a href="#">Download</a><a href="#">Changelog</a></div>
          <div className="foot-col"><h4>Who it's for</h4><a href={`${linkPrefix}who`}>Field Contractors</a><a href={`${linkPrefix}who`}>Real Estate Agents</a><a href={`${linkPrefix}who`}>Financial Advisors</a><a href={`${linkPrefix}who`}>Insurance Brokers</a></div>
          <div className="foot-col"><h4>Company</h4><a href="/about" data-testid="footer-about-link">About</a><a href={`${linkPrefix}story`}>Why Milk</a><a href="#">Careers</a><a href="#">Contact</a></div>
          <div className="foot-col"><h4>Legal</h4><a href="/privacy" data-testid="footer-privacy-link">Privacy</a><a href="/terms" data-testid="footer-terms-link">Terms</a></div>
        </div>
      </div>
      <div className="foot-bottom">
        <span>© {new Date().getFullYear()} Milk · addmilk.ai</span>
        <span>Made with less midnight, more daylight.</span>
      </div>
    </div>
  </footer>
);

export default MarketingFooter;
